import { TopicInstancesDocument } from '~/graphql';

export const topicInstancesCacheExchange = {
  optimistic: {
    updateTopicInstance(variables, cache, _info) {
      return {
        __typename: 'TopicInstanceResult',
        topicInstance: {
          __typename: 'TopicInstance',
          ..._info.variables,
          ...variables.updateTopicInstanceInput,
        },
      };
    },
  },
  updates: {
    Mutation: {
      //createTopicInstance(result, _args, cache, _info)
      createTopicInstance(result, _args, cache) {
        const courseId = _args.createTopicInstanceInput.courseId;

        cache.updateQuery(
          {
            query: TopicInstancesDocument,
            variables: {
              courseIdInput: { id: courseId },
            },
          },
          (data) => {
            if (data) {
              result.createTopicInstance.topicInstance.isNew = true;
              data.topicInstances.push({
                ...result.createTopicInstance.topicInstance,
              });
            }
            return data;
          }
        );
      },
      reorderTopicInstance(result, _args, cache) {
        const courseId = result.reorderTopicInstance.topicInstance.course.id;
        const topicInstanceId = _args.reorderTopicInstanceInput.id;
        const position = _args.reorderTopicInstanceInput.position;

        cache.updateQuery(
          {
            query: TopicInstancesDocument,
            variables: {
              courseIdInput: { id: courseId },
            },
          },
          (data) => {
            if (data) {
              for (let i = 0; i < data.topicInstances.length; i++) {
                if (data.topicInstances[i]?.id === topicInstanceId) {
                  data.topicInstances.splice(i, 1);
                }
              }
              data.topicInstances.splice(position, 0, result.reorderTopicInstance.topicInstance);
            }
            return data;
          }
        );
      },
      removeTopicInstance(result, _args, cache) {
        const topicInstanceId = _args.removeTopicInstanceInput.id;
        cache.invalidate({ __typename: 'TopicInstance', id: topicInstanceId });
      },
    },
  },
};
